<template>
  <div class="container mt-5">
    <div class="card modern-card">
      <div class="card-header">
        <h4 class="mb-0">
          <i class="fab fa-cc-stripe me-2"></i>
          Paiement par Carte Bancaire
        </h4>
      </div>

      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary"></div>
          <p class="mt-3 text-muted">Préparation du paiement...</p>
        </div>

        <div v-else-if="error" class="alert alert-danger">
          <i class="fas fa-exclamation-circle me-2"></i>
          {{ error }}
        </div>

        <div v-else>
          <div class="payment-info mb-4">
            <h5 class="info-title">Détails du paiement</h5>
            <div class="info-content">
              <div class="info-row">
                <span class="info-label">Référence BESC</span>
                <span class="info-value">{{ refbesc }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Montant</span>
                <span class="info-value">{{ formatNumber(amount) }} EURO</span>
              </div>
            </div>
          </div>

          <form id="payment-form" @submit.prevent="handleSubmit">
            <div class="payment-element-wrapper mb-4">
              <div id="payment-element"></div>
              <div 
                v-if="!isStripeReady"
                class="loading-overlay"
              >
                <div class="spinner-border spinner-border-sm text-primary"></div>
                <small class="d-block mt-2 text-muted">
                  Chargement du formulaire de paiement...
                </small>
              </div>
            </div>
            
            <button 
              type="submit" 
              class="btn btn-primary btn-payment w-100" 
              :disabled="isProcessing || !isStripeReady">
              <i v-if="isProcessing" class="fa fa-spinner fa-spin me-2"></i>
              <i v-else class="fas fa-credit-card me-2"></i>
              <span v-if="!isStripeReady">Préparation...</span>
              <span v-else-if="isProcessing">Traitement en cours...</span>
              <span v-else>Payer maintenant</span>
            </button>

            <div v-if="paymentMessage" class="alert mt-3" :class="paymentMessageType">
              <i class="fas fa-info-circle me-2"></i>
              {{ paymentMessage }}
            </div>
          </form>

          <div class="mt-3 text-center">
            <router-link to="/liste-besc" class="btn btn-outline-secondary btn-cancel">
              <i class="fas fa-arrow-left me-2"></i>
              Annuler et retourner
            </router-link>
          </div>

          <div class="text-center mt-4">
            <small class="secure-badge">
              <i class="fas fa-lock me-1"></i>
              Paiement sécurisé par Stripe
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { error as showError, success as showSuccess } from '@/utils/utils';

declare global {
  interface Window {
    Stripe?: any;
  }
}

export default defineComponent({
  name: 'PaiementStripe',
  setup() {
    const route = useRoute();
    const router = useRouter();

    const bescId = ref(route.params.id as string);
    const refbesc = ref('');
    const amount = ref(0);
    const loading = ref(true);
    const error = ref('');
    const isProcessing = ref(false);
    const paymentMessage = ref('');
    const paymentMessageType = ref('alert-info');
    const isStripeReady = ref(false); 

    let stripe: any = null;
    let elements: any = null;
    let paymentElement: any = null;

    const formatNumber = (val: number) => {
      return new Intl.NumberFormat('fr-FR').format(val);
    };

    // const loadBescInfo = async () => {
    //   try {
    //     const { data } = await ApiService.get(`/besc/${bescId.value}`);
    //     console.log("refinfooo",data);
    //     refbesc.value = data.data.refbesc;
    //     console.log("valllllll",data.data.coutBesc);

    //     if (!data.data.coutBesc || data.data.coutBesc <= 0) {
    //       error.value = 'Le montant du BESC n\'a pas encore été calculé. Veuillez soumettre le dossier pour générer la facture.';
    //       loading.value = false;
    //       return;
    //     }

    //     amount.value = data.data.coutBesc;
    //     loading.value = false;
    //   } catch (err: any) {
    //     error.value = 'Erreur de chargement du BESC';
    //     loading.value = false;
    //   }
    // };
    
    const loadBescInfo = async () => {
  try {
    const { data } = await ApiService.get(`/besc/${bescId.value}`);
    console.log("refinfooo", data);

    const besc = data.data;
    refbesc.value = besc.refbesc;

    const montantTotal = besc.facture?.montantTotal;
    console.log("montant facture", montantTotal);

    if (!montantTotal || Number(montantTotal) <= 0) {
      error.value =
        "Le montant du BESC n'a pas encore été calculé. Veuillez soumettre le dossier pour générer la facture.";
      loading.value = false;
      return;
    }

    amount.value = Number(montantTotal);

    loading.value = false;
  } catch (err: any) {
    console.error(err);
    error.value = "Erreur de chargement du BESC";
    loading.value = false;
  }
};

    const initStripe = async () => {
      return new Promise<void>((resolve, reject) => {
        try {
          if (window.Stripe) {
            console.log(' Stripe déjà chargé');
            initStripeElements().then(resolve).catch(reject);
            return;
          }

          const script = document.createElement('script');
          script.src = 'https://js.stripe.com/v3/';
          script.async = true;

          script.onload = async () => {
            console.log(' Script Stripe chargé');
            try {
              await initStripeElements();
              resolve();
            } catch (err) {
              reject(err);
            }
          };

          script.onerror = () => {
            error.value = 'Impossible de charger Stripe';
            reject(new Error('Script loading failed'));
          };

          document.head.appendChild(script);

        } catch (err: any) {
          console.error(' Erreur initStripe:', err);
          error.value = 'Erreur lors de l\'initialisation de Stripe';
          reject(err);
        }
      });
    };

    const initStripeElements = async () => {
      try {
        console.log(' Toutes les env vars:', {
        stripe: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
        paypal: process.env.VUE_APP_PAYPAL_CLIENT_ID,
        kkiapay: process.env.VUE_APP_KKIAPAY_PUBLIC_KEY,
        allEnv: process.env
      });
       const publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || 
      'pk_test_51JDXTeGXfBDkYkwpKxt2AjIL2ZXSXWGGkqXJpjNKwGTW0AjZJIONLDUYVa3TyY1QSveflJWBkc4n0Suu05bE9TJM00aeMQAQlI';

      console.log(' Clé utilisée:', publishableKey.substring(0, 20) + '...');

        if (!publishableKey) {
          error.value = 'Configuration Stripe manquante (VUE_APP_STRIPE_PUBLISHABLE_KEY)';
          console.error(' VUE_APP_STRIPE_PUBLISHABLE_KEY non défini');
          console.error(' Variables disponibles:', Object.keys(process.env));
          return;
        }

        console.log(' Clé publique Stripe:', publishableKey.substring(0, 20) + '...');
        
        if (!publishableKey.startsWith('pk_test_') && !publishableKey.startsWith('pk_live_')) {
          error.value = 'Clé publique Stripe invalide (doit commencer par pk_test_ ou pk_live_)';
          console.error(' Clé publique invalide:', publishableKey);
          return;
        }

        console.log(' Initialisation Stripe avec la clé publique');
        stripe = window.Stripe(publishableKey);

        console.log(' Création du PaymentIntent...');
        const response = await ApiService.post(
          `/besc/${bescId.value}/payment/stripe/create-intent`,
          {}
        );

        console.log(' Réponse complète:', response);
        console.log(' response.data:', response.data);
        
        let clientSecret: string | undefined;
        
        if (response.data?.data?.clientSecret) {
          clientSecret = response.data.data.clientSecret;
          console.log('ClientSecret trouvé dans data.data.clientSecret');
        } else if (response.data?.clientSecret) {
          clientSecret = response.data.clientSecret;
          console.log(' ClientSecret trouvé dans data.clientSecret');
        }

        if (!clientSecret) {
          console.error(' Structure de réponse:', JSON.stringify(response.data, null, 2));
          throw new Error('clientSecret manquant dans la réponse serveur');
        }

        console.log(' ClientSecret reçu:', clientSecret.substring(0, 20) + '...');

        elements = stripe.elements({ clientSecret });

        paymentElement = elements.create('payment');
        
        await new Promise<void>((resolve, reject) => {
          const timeout = setTimeout(() => {
            reject(new Error('Timeout: Payment Element non monté après 10s'));
          }, 10000);

          paymentElement.on('ready', () => {
            clearTimeout(timeout);
            console.log(' Payment Element prêt et monté');
            isStripeReady.value = true; 
            resolve();
          });

          paymentElement.on('loaderror', (event: any) => {
            clearTimeout(timeout);
            console.error(' Erreur chargement Payment Element:', event);
            reject(new Error('Erreur de chargement du Payment Element'));
          });

          console.log(' Montage du Payment Element...');
          paymentElement.mount('#payment-element');
        });

        console.log(' Payment Element monté avec succès');

      } catch (err: any) {
        console.error(' Erreur initStripeElements:', err);
        console.error(' Détails erreur:', err.response?.data);
        error.value = err.response?.data?.message || err.message || 'Erreur lors de l\'initialisation de Stripe';
        throw err;
      }
    };

    const handleSubmit = async () => {
      if (!isStripeReady.value || !stripe || !elements || !paymentElement) {
        paymentMessage.value = 'Le système de paiement n\'est pas encore prêt.';
        paymentMessageType.value = 'alert-warning';
        return;
      }

      isProcessing.value = true;
      paymentMessage.value = '';

      try {
        console.log(' Tentative de confirmation du paiement...');

        const { error: submitError, paymentIntent } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            return_url: `${window.location.origin}/paiement-success?bescId=${bescId.value}&method=stripe`,
          },
          redirect: 'if_required'
        });

        if (submitError) {
          console.error(' Erreur Stripe:', submitError);
          paymentMessage.value = submitError.message || 'Une erreur est survenue';
          paymentMessageType.value = 'alert-danger';
          isProcessing.value = false;
      } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      console.log(' Paiement réussi, PaymentIntent ID:', paymentIntent.id);
      
      try {
        console.log(' Mise à jour de la base de données...');
        
        const comment = sessionStorage.getItem(`besc_${bescId.value}_comment`) || '';
        console.log('Commentaire récupéré:', comment);
        
        await ApiService.post(
          `/besc/${bescId.value}/payment/stripe/confirm`,
          { 
            paymentIntentId: paymentIntent.id,
            comment 
          }
        );
        
        console.log(' Base de données mise à jour');
        showSuccess('Paiement effectué avec succès !');

        // → AJOUT ICI : Soumission automatique à validation (E10)
        try {
          await ApiService.post(`/besc/${bescId.value}/submit-for-validation`, {
            comment: `Paiement confirmé via Stripe - PaymentIntent ID: ${paymentIntent.id}`
          });
          console.log('Dossier soumis à validation avec succès');
          // Optionnel : message supplémentaire
          // showSuccess('Dossier soumis à validation automatiquement !');
        } catch (validationErr: any) {
          console.error('Erreur lors de la soumission à validation:', validationErr);
          // Ne bloque pas l'UX : le paiement est déjà pris
          // Tu peux logger ou notifier doucement
        }

        // Nettoyage
        sessionStorage.removeItem(`besc_${bescId.value}_comment`);
        
        // Redirection vers page de succès (impression)
        setTimeout(() => {
          router.push(`/paiement-success?bescId=${bescId.value}&method=stripe`);
        }, 1500);
        
      } catch (confirmError: any) {
        console.error(' Erreur lors de la confirmation backend:', confirmError);
        showError('Paiement effectué mais erreur de synchronisation. Contactez le support.');
        
        setTimeout(() => {
          router.push(`/paiement-success?bescId=${bescId.value}&method=stripe`);
        }, 2000);
      }
      
    } else {
      console.warn(' Statut PaymentIntent inattendu:', paymentIntent?.status);
      paymentMessage.value = 'Le paiement n\'a pas pu être confirmé';
      paymentMessageType.value = 'alert-warning';
      isProcessing.value = false;
    }
    
  } catch (err: any) {
    console.error(' Erreur handleSubmit:', err);
    paymentMessage.value = 'Une erreur inattendue est survenue';
    paymentMessageType.value = 'alert-danger';
    isProcessing.value = false;
  }
};

    onMounted(async () => {
      console.log(' Composant PaiementStripe monté');
      console.log(' BESC ID:', bescId.value);
      
      await loadBescInfo();
      
      if (!error.value) {
        try {
          await initStripe();
          console.log(' Stripe initialisé complètement');
        } catch (err) {
          console.error(' Échec initialisation Stripe:', err);
        }
      }
    });

    return {
      refbesc,
      amount,
      loading,
      error,
      isProcessing,
      isStripeReady, 
      paymentMessage,
      paymentMessageType,
      formatNumber,
      handleSubmit
    };
  }
});
</script>

<style scoped>
.modern-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, #0a59a4 0%, #0d6ec9 100%);
  color: white !important;
  padding: 1.5rem;
  border: none;
}

.card-header h4 {
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: -0.01em;
  color: white !important;
}

.card-header h4 i {
  color: white !important;
}

.card-body {
  padding: 2rem;
}

.payment-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  border-left: 4px solid #0a59a4;
}

.info-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.info-label {
  color: #6c757d;
  font-size: 0.95rem;
}

.info-value {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.95rem;
}

.payment-element-wrapper {
  position: relative;
  min-height: 200px;
}

#payment-element {
  min-height: 200px;
  padding: 1rem;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  z-index: 10;
}

.btn-payment {
  background-color: #0a59a4;
  border-color: #0a59a4;
  color: white;
  padding: 0.875rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-payment:hover:not(:disabled) {
  background-color: #084a8a;
  border-color: #084a8a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(10, 89, 164, 0.3);
}

.btn-payment:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.65;
}

.btn-cancel {
  border-radius: 8px;
  padding: 0.625rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
  transform: translateY(-1px);
}

.secure-badge {
  display: inline-flex;
  align-items: center;
  color: #6c757d;
  font-size: 0.875rem;
}

.secure-badge i {
  color: #28a745;
}

.spinner-border {
  width: 2rem;
  height: 2rem;
  border-width: 0.25em;
}

.spinner-border-sm {
  width: 1.5rem;
  height: 1.5rem;
}

.text-primary {
  color: #0a59a4 !important;
}

.alert {
  border-radius: 8px;
  padding: 1rem;
}

.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c2c7;
  color: #842029;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffecb5;
  color: #856404;
}

.alert-info {
  background-color: #e7f3ff;
  border-color: #b3d9ff;
  color: #0a59a4;
}

@media (max-width: 576px) {
  .card-body {
    padding: 1.5rem;
  }
  
  .payment-info {
    padding: 1rem;
  }
  
  .btn-payment {
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
  }

  #payment-element {
    min-height: 180px;
  }
}
</style>